export const IMAGES = {
  heroOffice: "/sede-hero.jpg",
  canonA3: "/canon-a3.jpg",
  canonA4: "/canon-a4.jpg",
  toner: "/toner.jpg",
  carta: "/carta.jpg",
  pc: "/pc-periferiche.jpg",
};

export const CATEGORIES = ["Tutti", "Noleggio", "Servizi"];

export const PROJECTS = [
  {
    id: "01",
    title: "Canon imageRUNNER A3 Colore",
    category: "Noleggio",
    year: "All-inclusive",
    location: "Milano e Provincia",
    client: "Uffici & Studi",
    image: IMAGES.canonA3,
    tags: ["Noleggio", "Canon A3"],
    brief: "Per uffici che stampano tanto e non possono permettersi fermi macchina.",
    concept: "Tutta la gamma imageRUNNER A3 a colori: alta velocità, fronte/retro automatico, finitore e scansione in rete.",
    result: "Canone mensile fisso con toner, ricambi e assistenza inclusi. Zero costi imprevisti.",
    aspect: "aspect-[4/5]",
  },
  {
    id: "02",
    title: "Canon imageRUNNER A4 Compatta",
    category: "Noleggio",
    year: "All-inclusive",
    location: "Milano e Provincia",
    client: "Piccole Imprese",
    image: IMAGES.canonA4,
    tags: ["Noleggio", "Canon A4"],
    brief: "Per piccoli uffici e studi professionali con spazi contenuti.",
    concept: "Tutta la gamma imageRUNNER A4: stampa, copia, scansione e fax in un unico dispositivo compatto e silenzioso.",
    result: "Installazione in giornata, configurazione di rete inclusa, toner sempre disponibili.",
    aspect: "aspect-[4/3]",
  },
  {
    id: "03",
    title: "Toner & Consumabili Canon",
    category: "Servizi",
    year: "Consegna rapida",
    location: "Milano e Provincia",
    client: "Uffici & Aziende",
    image: IMAGES.toner,
    tags: ["Toner", "Canon"],
    brief: "Restare senza toner nel momento sbagliato è il classico problema di ogni ufficio.",
    concept: "Toner originali Canon per tutta la gamma imageRUNNER e compatibili di qualità garantita, sempre a stock.",
    result: "Riordino programmato e consegna rapida: non resterete mai più senza.",
    aspect: "aspect-[4/3]",
  },
  {
    id: "04",
    title: "Fornitura di Carta",
    category: "Servizi",
    year: "Su richiesta",
    location: "Milano e Provincia",
    client: "Uffici & Aziende",
    image: IMAGES.carta,
    tags: ["Carta", "Su richiesta"],
    brief: "La carta finisce sempre nel momento peggiore: prima di una consegna importante.",
    concept: "Risme di carta A4 e A3 per ogni esigenza di stampa, disponibili come extra su richiesta.",
    result: "Consegna insieme ai consumabili: un unico fornitore per tutto l'ufficio.",
    aspect: "aspect-[4/5]",
  },
  {
    id: "05",
    title: "Vendita PC & Periferiche",
    category: "Servizi",
    year: "Vendita",
    location: "Milano e Provincia",
    client: "Aziende & Privati",
    image: IMAGES.pc,
    tags: ["Vendita", "Periferiche"],
    b2b: true,
    brief: "La postazione di lavoro completa, senza pensieri.",
    concept: "Vendita di PC, monitor, mouse, tastiere e tutte le periferiche per la postazione di lavoro, con installazione e configurazione incluse. Per aziende e privati.",
    result: "Un unico fornitore per stampa e postazioni PC: un solo interlocutore per tutto l'ufficio.",
    aspect: "aspect-[4/5]",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Affidabilità",
    quote: "Una stampante ferma è un ufficio fermo. Noi non ci fermiamo mai.",
    text: "Sappiamo che la multifunzione è il cuore dell'ufficio: per questo garantiamo macchine sempre efficienti e, in caso di guasto, una sostituzione rapida per non lasciarvi mai bloccati.",
  },
  {
    num: "02",
    title: "Rapidità",
    quote: "Chiami oggi, interveniamo entro 24 ore lavorative. Sempre.",
    text: "Niente ticket infiniti né call center anonimi: parli direttamente con i nostri tecnici, che conoscono la tua macchina e arrivano in sede con i ricambi giusti.",
  },
  {
    num: "03",
    title: "Trasparenza",
    quote: "Un canone chiaro, tutto incluso, nessuna sorpresa in fattura.",
    text: "Noleggio, toner, ricambi e assistenza in un'unica rata mensile. Sai sempre quanto spendi e cosa comprende: la parola 'extra' non fa parte del nostro vocabolario.",
  },
];

export const SERVICES = [
  {
    num: "01",
    title: "Noleggio Multifunzione",
    description: "Multifunzione Canon imageRUNNER a noleggio operativo — tutti i modelli — con formula all-inclusive pensata per uffici, aziende e privati.",
    deliverables: ["Consegna e installazione in sede", "Toner e consumabili inclusi", "Assistenza e ricambi inclusi", "Sostituzione in caso di guasto"],
  },
  {
    num: "02",
    title: "Assistenza Tecnica",
    description: "Tecnici qualificati per interventi rapidi su multifunzione Canon imageRUNNER e imageFORCE.",
    deliverables: ["Intervento on-site entro 24 ore", "Contratti di manutenzione programmata", "Ricambi originali e garantiti", "Supporto telefonico e remoto"],
  },
  {
    num: "03",
    title: "Forniture & Consumabili",
    description: "Toner e materiali di consumo con riordino programmato e consegna rapida. Fornitura carta disponibile come extra su richiesta.",
    deliverables: ["Toner originali e compatibili", "Fornitura carta (extra su richiesta)", "Riordino automatico programmato", "Consegna rapida in zona"],
  },
  {
    num: "04",
    title: "Computer & Periferiche",
    description: "Riparazione e manutenzione di computer e periferiche. Vendita di PC, mouse, tastiere e tutto quello che riguarda la postazione di lavoro. Per aziende e privati.",
    deliverables: ["Riparazione PC e periferiche", "Manutenzione postazioni di lavoro", "Vendita PC, mouse e tastiere", "Per aziende e privati"],
    b2b: true,
  },
];

export const CONTACTS = {
  email: "info@furlanprintcopy.it",
  phone: "0240137002",
  phoneRaw: "+390240137002",
  mobile: "346 086 8653",
  mobileRaw: "+393460868653",
  website: "www.furlanprintcopy.it",
  websiteUrl: "https://www.furlanprintcopy.it",
  address: "Viale dell'Industria 3 — 20037 Paderno Dugnano (MI)",
  hours: "Lun – Ven · 9:00 – 13:00 / 14:00 – 18:00 · Sabato · 9:00 – 13:00",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Viale+dell'Industria+3+Paderno+Dugnano",
  whatsappUrl: "https://wa.me/393460868653?text=Buongiorno%2C%20vorrei%20informazioni%20sul%20noleggio%20multifunzione",
  piva: "14888840965",
};
